module.exports = __webpack_public_path__ + "img/currency-bitcoin.2c36ec4b.svg";